import { ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, ViewChild} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { getAuth } from "firebase/auth";
import { AddusertoprojectdialogComponent } from '../addusertoprojectdialog/addusertoprojectdialog.component';
import { AuthService } from '../auth.service';
import { SharedServiceService } from '../shared-service.service';
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import { FirestoreService } from '../firestore-service.service';
import { Subscription, filter } from 'rxjs';
import { SearchService } from '../search.service';
import { environment } from 'src/environments/environment';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FeedbackpopupComponent } from '../feedbackpopup/feedbackpopup.component';

@Component({
    selector: 'app-header',
    templateUrl: environment.site === 'wroolo' ? './header.component.wroolo.html' : './header.component.productly.html',
    styleUrls: ['./header.component.scss'],
    standalone: true,
    imports: [
      CommonModule, 
      FormsModule,
      FeedbackpopupComponent
    ]
})
export class HeaderComponent implements OnDestroy {

  @Input() noProjectKeyNeeded: boolean = false // w productly header is subcomponent of main component, so it is not necesary to validate access
  @Input() organizationKey: string = "";
  @Input() userId: string = "";
  @Input() segment: string = "";
  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;

  projectKey: string = "";
  isAnonymous: boolean = true
  userEmail: string = "";
  userPhotoURL: string = "";
  userDisplayname: string = "";
  userOrganizations: {"key": string, "name": string}[] = []
  userProjects: {"key": string, "name": string, "isOwner": boolean}[] = []
  organizationName: string = "";
  projectName: string = "";
  refProjects: any;
  isCanvasSelected: boolean = false
  isKanbanSelected: boolean = false
  isMapSelected: boolean = false
  isKnowledgeSelected: boolean = false
  isDiscussionSelected: boolean = false
  isStaffSelected: boolean = false
  unsubscribeProjects: any;
  doShowTutorial: boolean = false;
  menuItems: {key: string, name: string, color: string}[] = []
  menuPostItems: {key: string, name: string, color: string}[] = []
  searchQuery = ""
  isSearchVisible = true
  loggedOut = false
  isListeningToOrgProjChanges = true
  showProjectDropDown = false
  unsubOrg: any
  unsubPrj: any
  unsubisProjectVisible: any
  unsubdoRefreshOrgs: any
  unsubisHeaderVisible: any
  unsubisSearchVisible: any
  returningFromLoggingOut = false
  isHeaderVisible = false
  isChatVisible = false
  isProjectVisible = true
  isProjectReadOnly = false
  isReadOnly = false
  postCount = 0
  taskCount = 0
  feedbackPopupVisible = false
  countFeedbackPopupDisplayed = 0
  allowedRoutes = ["features", "benefits", "solutions", "landing", "pkms", "blogpost", "about", "sig", "pricing", "login", "privacy", "terms", "blog", "news", "taglistadmin"] // allowed routes for logged out users, other routes are redirected to landing page
  private routerSubscription: Subscription | undefined;
  selectedContentKeys: string[] = [] // array of posts that are selected by user
  unsubscribeSelectedContentKeys: any
  site = ""
  systemName = ""
  isMac = false

  globalKeyHandler = (event: KeyboardEvent) => {
    const commandOrControl = this.isMac ? event.metaKey : event.ctrlKey;
    if (commandOrControl && event.key.toLowerCase() === 'k') {
      event.preventDefault();
      this.searchInput?.nativeElement.focus();
      this.searchInput?.nativeElement.select();
    }
  };

  constructor(private _route: ActivatedRoute, private authService: AuthService, private router: Router, private service: SharedServiceService, public dialog: MatDialog, private firestoreService: FirestoreService, private cdr: ChangeDetectorRef, private searchService: SearchService) { 
    this.unsubisProjectVisible = this.service.isProjectVisible.subscribe(isProjectVisible => {
      this.isProjectVisible = isProjectVisible
    })
    this.unsubscribeSelectedContentKeys = this.service.selectedContentKeys.subscribe(selectedContentKeys => {
      this.selectedContentKeys = selectedContentKeys
    })
  }

  ngOnInit(): void {
    this.isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    this.site = environment.site
    if (this.site == "wroolo") {
      this.systemName = "Wroolo"
    } else {
      this.systemName = "Productly"
    }
    const pathParts = window.location.pathname.split('/', 2);
    this.segment = pathParts[1].trim();
    this.segment = this.segment.replace(" ", "");
    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
          const pathParts = window.location.pathname.split('/', 2);
          this.segment = pathParts[1].trim();
          this.segment = this.segment.replace(" ", "");
         // this.cdr.detectChanges();
      });
  }

  ngAfterViewInit() {
    window.addEventListener('keydown', this.globalKeyHandler, true);
    this.service.isLoadingLabelVisible = false
    this.isHeaderVisible = this.service.currentisHeaderVisible
    getAuth().onAuthStateChanged(user => { // wait to get authorized
      if (user != null && user.email) { // User is signed in or token was refreshed.
        this.isAnonymous = false
        this.projectKey = this.service.currentProjectKey
        if (this.organizationKey == "" || this.organizationKey == undefined || this.organizationKey == null) {
          this.organizationKey = this.service.currentOrganizationKey
        }
        if ((this.projectKey == "" || this.projectKey == undefined || this.projectKey == null) && this.organizationKey != "") { // if projectKey is empty, check if user has any invitations
          this.firestoreService.getUserInvitationsByOrganization(this.organizationKey, user.email).then(invitations => {
            invitations.forEach(invitation => {
            this.firestoreService.addUserToProject(this.organizationKey, invitation.projectKey, invitation.projectName, this.userId).then(() => { // if user has any invitations, add him to the projects immediately
              this.projectKey = invitations[0].projectKey
            }).catch(error => {
              console.error("error", error)
            })
          })
            
          })
        }
        this.userId = user.uid
        this.service.userId = this.userId
        if (user.displayName) {
          this.userDisplayname = user.displayName
          this.service.userDisplayname = this.userDisplayname
        }
        if (user.email) {
          this.userEmail = user.email
          this.service.userEmail = this.userEmail
        }
        this.showFeedbackPopup()
        this.refreshOrgs()
        this.unsubdoRefreshOrgs = this.service.doRefreshOrgs.subscribe(r => { // I need to listen to it because in the wizard new organization maybe added
          if (r == true) {
            this.refreshOrgs()
          }
        })
        this.unsubisHeaderVisible = this.service.isHeaderVisible.subscribe(h => {
          this.isHeaderVisible = h
        })
        this.updateUserData(user)
        
        if (this.service.userProjects.length > 0) {
          this.userProjects = [...this.service.userProjects]
        } else {
          if (this.organizationKey != "" && this.organizationKey != undefined && this.organizationKey != null) {
            this.firestoreService.getUserOrganizationProjects(this.organizationKey, this.userId).then(prjs => {
            this.userProjects = [...prjs]
            this.service.userProjects = [...prjs]
            if ((this.projectKey == "" || this.projectKey == undefined || this.projectKey == null) && this.userProjects.length > 0) {
              this.projectKey = this.userProjects[0].key
            } else {
              this.projectName = this.getProjectName(this.projectKey)
            }
            if ((this.userProjects.length == 0 || this.projectKey == "" || this.projectKey == undefined || this.projectKey == null) && !this.noProjectKeyNeeded) { // if now projects were retrieved for given user and organization, redirect user to startscreen
              this.firestoreService.showSnackBar("You don't have access to this project. Redirecting to your project list.")
              this.router.navigate(["startscreen"])
            }

           })
          }
        }
     } else { // if user is not logged in, log out

     // if ((this.segment != 'features')&&(this.segment != 'benefits')&&(this.segment != 'solutions')&&(this.segment != 'landing')&&(this.segment != 'pkms')&&(this.segment != 'blogpost')&&(this.segment != 'about')&&(this.segment != 'sig')&&(this.segment != 'pricing')&&(this.segment != 'login')&&(this.segment != 'privacy')&&(this.segment != 'terms')&&(this.segment != 'blog')&&(this.segment != 'news')) { // if user is not on landing or other static pages, redirect him to landing page
     if (!this.allowedRoutes.includes(this.segment)) {
        this.router.navigate(['landing'])
      }
     }
    });
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }

    this.organizationKey = ""
    this.projectKey = ""
    this.unsubscribe()
    if (this.unsubisProjectVisible) {
      this.unsubisProjectVisible.unsubscribe()
    }
    if (this.unsubdoRefreshOrgs) {
      this.unsubdoRefreshOrgs.unsubscribe()
    }
    if (this.unsubisHeaderVisible) {
      this.unsubisHeaderVisible.unsubscribe()
    }
    if (this.unsubisSearchVisible) {
      this.unsubisSearchVisible.unsubscribe()
    }
    if (this.unsubscribeSelectedContentKeys) {
      this.unsubscribeSelectedContentKeys.unsubscribe()
    }
    window.removeEventListener('keydown', this.globalKeyHandler, true);
  }

  unsubscribe() {
    if (this.unsubscribeProjects) {
      this.unsubscribeProjects()
    }
    if (this.unsubOrg) {
      this.unsubOrg.unsubscribe()
    }
    if (this.unsubPrj) {
      this.unsubPrj.unsubscribe()
    }

  }

  containsOrganizationKey(keyToCheck: string): boolean {
    return this.userOrganizations.some(obj => obj.hasOwnProperty('key') && obj.key === keyToCheck);
  }

  checkKey(event: KeyboardEvent) {
    const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    const commandOrControl = isMac ? event.metaKey : event.ctrlKey;

    if (commandOrControl && event.key === 'k') {
      event.preventDefault(); // Prevents the default action (if necessary)
      this.search(this.searchQuery, false); // Triggers the search
    }
  }

  async refreshOrgs() {
    if (this.organizationKey != this.service.currentOrganizationKey) {
      this.organizationKey = this.service.currentOrganizationKey
    }
    if (this.organizationKey == "" || this.organizationKey == undefined) {
      this.organizationKey = await this.firestoreService.getDefaultOrganizationKey(this.userId)
      this.projectKey = await this.firestoreService.getDefaultProjectKey(this.organizationKey, this.userId)
    }
    this.unsubscribe()
    if (this.organizationKey != undefined && this.organizationKey != "") { // I have to add, cause if I am displaying this page for the first time, service.organizationKey.subscribe is not fired yet
      this.getTemplateNames(this.organizationKey)
    }
    this.unsubOrg = this.service.organizationKey.subscribe(org => { // listen to organizationKey passed from query in component (I can't listen to query in header component for it is not defined in routing_module)
      this.getTemplateNames(org)
      if (!this.containsOrganizationKey(org)) {
        this.firestoreService.getOrganizations(this.userId).then((usOrg: any) => { // get organizations assigned to user
          this.userOrganizations = [...usOrg]
          this.organizationName = this.getOrganizationName(this.organizationKey)
          this.service.organizationName = this.organizationName
        })
      }
      if ((org != undefined && org != "undefined" && org != "" && org != this.organizationKey)|| (/*org != this.organizationKey ||*/ this.returningFromLoggingOut == true)) {
        this.returningFromLoggingOut = false
        this.organizationKey = org
        this.firestoreService.getUserOrganizationProjects(this.organizationKey, this.userId).then(prjs => {
          this.userProjects = prjs
         })
      }
    })
    this.firestoreService.getOrganizations(this.userId).then((usOrg) => { // get organizations assigned to user
      this.userOrganizations = usOrg
      this.organizationName = this.getOrganizationName(this.organizationKey)
      this.service.organizationName = this.organizationName
    })
    this.unsubPrj = this.service.projectKey.subscribe(prj => { // subscribe to changes to projectkey coming from other components
      if (prj != undefined && prj != "undefined" && prj != "" && prj != this.projectKey) {
        this.projectKey = prj
      } 
       this.firestoreService.getProjectReadOnlyStatus(this.organizationKey, this.projectKey, this.userId).then(readonly => {
        this.isReadOnly = readonly
      })
      /*this.getUserProjects(this.projectKey).then(() => {
        this.projectName = this.getProjectName(this.projectKey)
      })*/
    })
  }

  updateUserData(user: any) {
    this.unsubisSearchVisible = this.service.isSearchVisible.subscribe(search => {
      this.isSearchVisible = search
    })

    this.loggedOut = false
    this.isAnonymous = false
   // this.loggeduserDisplayname = user.displayName as string
   // this.service.loggeduserDisplayname = user.displayName
    this.userId = user.uid
    //this.service.userId = this.userId
    //this.loggeduserEmail = user.email as string
  //  this.service.loggeduserEmail = this.loggeduserEmail
   // this.loggeduserPhotoURL = user.photoURL as string
    this.firestoreService.getUserData(this.userId).then(result => {
      this.userPhotoURL = result.get("photoUrl") || ""
      this.userEmail = result.get("email") || ""
      this.userDisplayname = result.get("displayName") || ""

      if ((this.userPhotoURL == null || this.userPhotoURL == '' || this.userPhotoURL == undefined) && (user.photoURL != null && user.photoURL != '' && user.photoURL != undefined)) { // update image of user
        this.firestoreService.updateUserPhoto(this.userId, this.userPhotoURL)
        this.userPhotoURL = this.service.userPhotoURL
      }
      if ((this.userDisplayname == null || this.userDisplayname == undefined || this.userDisplayname == '') && (user.displayName != null && user.displayName != '' && user.displayName != undefined)) { // if no user name is provided, take user email
        this.userDisplayname = user.displayName as string
        this.firestoreService.updateUserDisplayName(this.userId, this.userDisplayname)
      }
      if ((this.userEmail == null || this.userEmail == undefined || this.userEmail == '') && (user.email != null && user.email != '' && user.email != undefined)) {
        this.userEmail = user.email as string
        this.firestoreService.updateUserEmail(this.userId, this.userEmail)
      }
      this.service.userDisplayname = this.userDisplayname
      this.service.userEmail = this.userEmail
      this.service.userPhotoURL = this.userPhotoURL
    })

    this.firestoreService.updateLoginDate(this.userId, this.userEmail, this.userDisplayname) // update user login date
    
  }


  /*checkIfShowTutorial() {
    this.firestoreService.checkIfShowTutorial(this.userId).then(result => {
      this.doShowTutorial = result
      if (this.doShowTutorial == true) {
        this.isListeningToOrgProjChanges = false
       // this.service.changeOrganization(this.organizationKey)
      //  this.service.changeProject(this.projectKey)
        this.router.navigate(["tutorial"])
      }
    })
  }*/

  getProjectByKey(key: string) {
    for (let i = 0; i < this.userProjects.length; i++) {
      if (this.userProjects[i].key == key) {
        return i
      }
    }
    return -1
  }

  logOut() { // sign out and redirect to login page
    if (this.unsubOrg) {
      this.unsubOrg.unsubscribe()
    }
    if (this.unsubPrj) {
      this.unsubPrj.unsubscribe()
    }
    this.userProjects.splice(0, this.userProjects.length)
    this.userOrganizations.splice(0, this.userOrganizations.length)
    this.organizationKey = ""
    this.service.changeOrganization("")
    this.projectKey = ""
    this.service.changeProject("")
    this.userId = ""
    this.loggedOut = true
    this.isAnonymous = true
    this.authService.signOut()
    this.returningFromLoggingOut = true
  }

  copyTextToClipboard(text: string) {
    text = "https://wroolo.com/feed/"+text
    this.firestoreService.copyTextToClipboard(text);
  }

  async getUserProjects(defaultProjectKey: string) {
    return await this.firestoreService.getUserOrganizationProjects(this.organizationKey, this.userId).then(prjs => {
      if (prjs.length > 0) { // if there are any projects in the organization visible to the user
        this.userProjects.length = 0
        this.userProjects = prjs
        if (this.userProjects.filter(e => e.key === defaultProjectKey).length == 0) { // there is no such default project key in array of projects
          if (this.projectKey != this.userProjects[0].key) {
            this.projectKey = this.userProjects[0].key
            this.projectName = this.getProjectName(this.projectKey)
            this.firestoreService.setDefaultProject(this.organizationKey, this.userId, this.projectKey) // assign the first project as default
          }
        } else { // if projectKey exists in list of projects
          if (this.projectKey != defaultProjectKey) {
            this.projectKey = defaultProjectKey
            this.projectName = this.getProjectName(this.projectKey)
          }
        }
        const segments = window.location.pathname.split('/', 2)
        console.log("getUserProjects 1 segments", segments)
        if (segments[1] == "error" ) { // if user is on error page and changed organization so he sees any projects, redirect him to knowledge base
          this.router.navigate(["feed/"+this.organizationKey+"/"+this.projectKey])
        } else { // if user is not on error page, keep him in the page in gieven the url
          if (segments[1] == "storymap") {
            this.router.navigate(["/canvaslist", this.organizationKey, this.projectKey])
          } else {
            this.router.navigate([segments[1]+"/"+this.organizationKey+"/"+this.projectKey])
          }
        }
      } else { // if there are no projects in the organization visible to the user
        this.firestoreService.showSnackBar("There are no projects available for you. Add new project in administration panel or ask for access to the existing one.")
        this.router.navigate(["error/noprojects"])
      }

    })
  }

  changeOrganization(event: any) {
    if (this.organizationKey != undefined) {
      this.userProjects.length = 0
      this.firestoreService.getDefaultProjectKey(this.organizationKey, this.userId).then((defProj) => {
        if (defProj != "" && defProj != undefined) {
          this.getUserProjects(defProj)
        } else {
          this.getUserProjects("")
        }

      })
    } else { // if not... organization is not defined
    }
  }

  getOrganizationName(key: string) {
    if (key != undefined && key != "" && this.userOrganizations.length > 0) {
      for (let i = 0; i < this.userOrganizations.length; i++) {
        if (this.userOrganizations[i].key == key) {
          return this.userOrganizations[i].name
        }
      }
    }
    return ""
  }

  getProjectName(key: string) {
    for (let i = 0; i < this.userProjects.length; i++) {
      if (this.userProjects[i].key == key) {
        this.service.projectName = this.userProjects[i].name
        return this.userProjects[i].name
      }
    }
    return ""
  }

  search(queryString: string, isAISearch: boolean) {
    if (queryString != "") {
      if (this.segment == "search") {
        this.service.changeSearchQuery(queryString)
      } else {
        if (isAISearch == true) {
          this.router.navigate(["search/"+this.organizationKey+"/"+this.projectKey+"/"+queryString])
        } else {
          this.router.navigate(["feed/"+this.organizationKey+"/"+this.projectKey+"/"+queryString])
        }
      }
    } else {
      this.firestoreService.showSnackBar("Please enter a search query.")
    }
  }

  ask(query: string = "") {
    if (query == "") {
      query = "false"
    }
    this.router.navigate(["search/"+this.organizationKey+"/"+this.projectKey+"/"+query])
  }

  changeProject(event: any) {
    this.service.currentSelectedContentKeys = []
    this.service.changeSelectedContentKeys(this.service.currentSelectedContentKeys)
    this.service.responseChunks = []
    this.service.responseSourceDocuments = []
    const segments = window.location.pathname.split('/', 2)
    console.log("changeProject 1 segments", segments)
    if (segments[1] == "storymap") {
      this.router.navigate(["canvaslist"+"/"+this.organizationKey+"/"+this.projectKey])// go to canvas list if on canvas when changing project
    } else {
      this.router.navigate([segments[1]+"/"+this.organizationKey+"/"+this.projectKey])// if project was changed from dropdown reload the page with proper parameters
    }
  }

  navigateToProjects() {
    this.router.navigate(["startscreen"])
  }

  navigateToReport() {
    this.router.navigate(["timetracking/"+this.organizationKey+"/"+this.projectKey])
  }

  navigateToWiki() {
    this.router.navigate(["wiki/"+this.organizationKey+"/"+this.projectKey])
  }

  navigateToAdmin() {
    this.router.navigate(["admin/"+this.organizationKey])
  }

  nagivateToUser() {
    this.router.navigate(["login"])
  }

  navigateToChatList() {
    this.router.navigate(['discussion/'+this.organizationKey+'/'+this.projectKey])
  }

  navigateToValidator() {
    this.router.navigate(['validator/'+this.organizationKey+'/'+this.projectKey])
  }

  navigateTo(segment: string, organizationKey: string = "", projectKey: string = "") {
    if (organizationKey == "") {
      this.router.navigate([segment])
    } else if (projectKey == "") {
      this.router.navigate([segment+"/"+organizationKey])
    } else {
      this.router.navigate([segment+"/"+organizationKey+"/"+projectKey])
    }
  }

  addUserToProject() {
    const dialogRef = this.dialog.open(AddusertoprojectdialogComponent, {
     // panelClass: "dialog-container",
     width: '400px',
     maxWidth: '90vw',
      data: {  },
    });
    this.organizationName = this.getOrganizationName(this.organizationKey)
    dialogRef.afterClosed().subscribe((data) => { // when dialog is closed, store data in the database
      const email = data.email
      if ((email != undefined)&&(email != "")) {
        this.firestoreService.getUserIdByEmail(email).then((snapshot) => {
          if (snapshot != undefined && snapshot.userId != undefined && snapshot.userId != "") { // if user exists, add him to org and project TO NIE DZIAŁA, JEŻELI USER NIE JEST JUŻ ZAREJESTROWANY W WROOLO!!!
            const userName = snapshot.userName || "anonymous"
            this.registerExistingUserToProject(snapshot.userId, userName, email)
          } else {  // if user doesn't exist just send invitation
            this.registerNewUserToProject(email)
          }
        })
      }
    });
}

async registerExistingUserToProject(userId: string, userName: string, email: string) {
  await this.firestoreService.addUserToOrganization(this.organizationKey, this.organizationName, userId, userName, email)
  await this.firestoreService.addUserInvitationToProject(this.organizationKey, email, this.projectKey, this.projectName, userId, this.userId, this.userDisplayname, this.systemName, this.organizationName)
  await this.firestoreService.addUserToProject(this.organizationKey, this.projectKey, this.projectName, userId)
  this.firestoreService.showSnackBar("The invitation has been sent.");
}

async registerNewUserToProject(email: string) {
  const key = await this.firestoreService.addUserManually(email, this.organizationKey, this.organizationName, this.projectKey, this.projectName).then((key) => {
    return key
    })
 // await this.firestoreService.addUserToOrganization(this.organizationKey, this.organizationName, key, email, email)
 // await this.firestoreService.addUserToProject(this.organizationKey, this.projectKey, this.projectName, key)
  await this.firestoreService.registerUserWelcome(this.organizationKey, this.organizationName, this.projectKey, this.projectName, email,this.userId, this.systemName)
  this.firestoreService.showSnackBar("Remember that invited user must be registered in the Wroolo system using email "+email+".")
  await this.firestoreService.addUserInvitationToProject(this.organizationKey, email, this.projectKey, this.projectName, key, this.userId, this.userDisplayname, this.systemName, this.organizationName)// add user email to invited emails collection
}

async getTemplateNames(organizationKey: string) { // downloads list of available templates for workpackages and posts
  await this.firestoreService.getTemplates(organizationKey).then(result => {
    this.menuPostItems.length = 0
    this.menuItems.length = 0
    result.forEach(r => {
      const key = r.id
      const type = r.get("type")
        if (type == "workpackage") {
          this.menuItems.push({"key": key, "name": r.get("name"), "color": r.get("color")})
        }
        if (type == "post") {
          this.menuPostItems.push({"key": key, "name": r.get("name"), "color": r.get("color")})
        }
    })
    setTimeout(() => { // if I don't add small delay key is undefined. it seams that result.foreach doesn't make angular wait
      this.service.changeWorkpackageTypes(this.menuItems)
      this.service.changePostTypes(this.menuPostItems)
   }, 10)
  })
}

showChat() {
  this.isChatVisible = true
  this.service.changeChatVisible(this.isChatVisible)
}

hideChat() {
  this.isChatVisible = false
  this.service.changeChatVisible(this.isChatVisible)
}

showFeedbackPopup() {
  const lastPopupDate = localStorage.getItem('feedbackPopupLastShown');
  const currentDate = new Date();
  
  if (lastPopupDate) {
    const lastShownDate = new Date(lastPopupDate);
    const diffTime = Math.abs(currentDate.getTime() - lastShownDate.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // Convert time difference to days

    if (diffDays < 10) {
      // Popup has been shown in the last 20 days, do not show it again
      return;
    }
  }

  // Show the popup and update the last shown date
  setTimeout(() => {
    this.feedbackPopupVisible = true;
    // Update the last shown date in localStorage
    localStorage.setItem('feedbackPopupLastShown', currentDate.toISOString());
  }, 10000); // Show the popup after 10 seconds
}

reindexAllContent() { // use this function to reindex all content in the organization, it is not launched normally
  this.searchService.reindexAllContent(this.organizationKey, this.userId, 2400)
}

}

